var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCrystalScroll = function SvgCrystalScroll(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crystal_scroll_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 1000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient",
    cx: 322.8248,
    cy: 297.5209,
    r: 244.2377,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ceaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    stopColor: "#23afad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#6476a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d5fa7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-2",
    cx: 307.2857,
    cy: 375.7305,
    r: 183.1557,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-3",
    cx: 356.6577,
    cy: 327.4151,
    r: 184.7842,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-4",
    cx: 310.37,
    cy: 329.3516,
    r: 240.3012,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-5",
    cx: 324.5604,
    cy: 324.5456,
    r: 275.2232,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-6",
    cx: 270.979,
    cy: 277.9005,
    r: 393.9144,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-7",
    cx: 297.4462,
    cy: 205.2456,
    r: 341.0425,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-8",
    cx: 365.8332,
    cy: 328.729,
    r: 134.5754,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1848,
    stopColor: "#17c9b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    stopColor: "#58d9ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71dfa9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-9",
    cx: 449.4467,
    cy: 384.2551,
    r: 138.7992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04c0c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#2ad4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e2ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-10",
    cx: 456.2158,
    cy: 364.6869,
    r: 194.5211,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-11",
    cx: 384.4313,
    cy: 367.0769,
    r: 118.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cd3b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2731,
    stopColor: "#68d4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    stopColor: "#5cd5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8274,
    stopColor: "#48d8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37dabc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-12",
    cx: 424.8354,
    cy: 342.7435,
    r: 159.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76eaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6760ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-13",
    cx: 431.9972,
    cy: 287.4271,
    r: 167.811,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c3be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbabf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72aac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8e94c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e88c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-14",
    cx: 382.1975,
    cy: 500.9329,
    r: 318.6401,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-15",
    cx: 353.6667,
    cy: 415.0224,
    r: 199.9265,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-16",
    cx: 358.4505,
    cy: 439.989,
    r: 258.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-17",
    cx: 325.4835,
    cy: 462.4066,
    r: 149.384,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-18",
    cx: 271.1306,
    cy: 480.056,
    r: 239.6997,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-19",
    cx: 340.2527,
    cy: 471.6062,
    r: 370.2564,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-20",
    cx: 370.9724,
    cy: 429,
    r: 221.1684,
    gradientTransform: "translate(-205.7353 802.7104) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f77a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f18c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-21",
    cx: 387.5869,
    cy: 482.2147,
    r: 122.5169,
    gradientTransform: "translate(-205.7353 802.7104) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    stopColor: "#99f76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    stopColor: "#57f188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eef93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-22",
    cx: 576.3885,
    cy: 438.9889,
    r: 129.6362,
    gradientTransform: "translate(-205.7353 802.7104) rotate(-91.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-23",
    cx: 257.8088,
    cy: 362.0084,
    r: 149.4797,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4754,
    stopColor: "#a0f596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    stopColor: "#5ef9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-24",
    cx: 448.7858,
    cy: 349.302,
    r: 173.0918,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4345,
    stopColor: "#50dac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    stopColor: "#92e99c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abee8d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-25",
    cx: 229.7178,
    cy: 386.9667,
    r: 158.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8e0ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0649,
    stopColor: "#c1e1ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#80eca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67f0a5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-26",
    cx: 240.2788,
    cy: 213.9654,
    r: 70.5853,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64f968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#6af66f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe988"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-27",
    cx: 436.5506,
    cy: 235.4979,
    r: 132.9737,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-28",
    cx: 457.194,
    cy: 331.2785,
    r: 174.5168,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad7b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43ebab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-29",
    cx: 426.4617,
    cy: 376.9275,
    r: 143.0893,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2adaa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-30",
    cx: 473.329,
    cy: 447.4716,
    r: 276.2517,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009cd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#39c2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7934,
    stopColor: "#7aec95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93fd89"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-31",
    cx: 343.6051,
    cy: 295.9231,
    r: 79.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34e09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#6cf27c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85fa6c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-32",
    cx: 115.5448,
    cy: 292.2888,
    r: 469.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07d887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#35a08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a8791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-33",
    cx: 82.4679,
    cy: 529.0018,
    r: 215.5438,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-34",
    cx: 187.2857,
    cy: 504.6044,
    r: 205.5282,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-35",
    cx: 251.5,
    cy: 545.7123,
    r: 118.1565,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-36",
    cx: 193.0543,
    cy: 435.1558,
    r: 278.2346,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-37",
    cx: 145.98,
    cy: 416.0072,
    r: 373.0061,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-38",
    cx: 232.5461,
    cy: 398.0049,
    r: 214.8636,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-39",
    cx: 260.8681,
    cy: 406.2308,
    r: 197.4594,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-40",
    cx: 196.3988,
    cy: 312.447,
    r: 386.3936,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-41",
    cx: 64.7854,
    cy: 231.9252,
    r: 580.5636,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-32"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-42",
    cx: 132.7842,
    cy: 349.4455,
    r: 148.9581,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381,
    stopColor: "#f6fe44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#8ff171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8452,
    stopColor: "#4de88e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34e599"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-43",
    cx: 283.022,
    cy: 570.1189,
    r: 203.9856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#25c698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    stopColor: "#66df9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fe99b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-44",
    cx: 376.6439,
    cy: 524.3219,
    r: 300.5038,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2712,
    stopColor: "#26c4a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#67de9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-45",
    cx: 336.6525,
    cy: 661.496,
    r: 243.959,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0194,
    stopColor: "#02b5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    stopColor: "#43bb95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cbd85"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-46",
    cx: 216.4335,
    cy: 502.1666,
    r: 159.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ae8c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fb57f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-47",
    cx: 290.6436,
    cy: 673.2529,
    r: 161.0665,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#168492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#52bb9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bd2a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-48",
    cx: 243.8791,
    cy: 546.5571,
    r: 129.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cc29a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3545,
    stopColor: "#37bea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b7ac"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-49",
    cx: 432.0044,
    cy: 528.5717,
    r: 211.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a07f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    stopColor: "#23b28e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#64d4a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7de1b4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-50",
    cx: 288.033,
    cy: 588.4725,
    r: 373.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ae8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fb57f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-51",
    cx: 180.7245,
    cy: 282.3162,
    r: 82.0429,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-52",
    cx: 288.2269,
    cy: 602.6007,
    r: 50.6516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ab48b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54bac4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-53",
    cx: 108.6779,
    cy: 555.0255,
    r: 453.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#4c8782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    stopColor: "#6946b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752dce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-54",
    cx: 121.4176,
    cy: 535.0659,
    r: 415.1728,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-53"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-55",
    cx: 92.8641,
    cy: 480.8455,
    r: 524.3082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2446,
    stopColor: "#449f74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7577,
    stopColor: "#6761b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7549ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-56",
    cx: 190.8002,
    cy: 515.7741,
    r: 344.4723,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-53"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-57",
    cx: 138.967,
    cy: 542.9844,
    r: 390.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cbf53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    stopColor: "#5c8782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    stopColor: "#6e46b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752dce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-58",
    cx: 80.357,
    cy: 489.2778,
    r: 526.196,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-53"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-59",
    cx: 14.4525,
    cy: 627.3291,
    r: 225.4248,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-60",
    cx: 284.4365,
    cy: 570.0769,
    r: 186.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fea95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8087fe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-61",
    cx: 192.4144,
    cy: 626.0891,
    r: 137.2539,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72c2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#71c0c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#6fbacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#6bafe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#66a1fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66a0ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-62",
    cx: 128.1988,
    cy: 706.4015,
    r: 155.4494,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    stopColor: "#31c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    stopColor: "#3dbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    stopColor: "#52b3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    stopColor: "#6ea5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#9292d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9690d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-63",
    cx: 306.9153,
    cy: 726.006,
    r: 170.0956,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97aaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#61c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48d5b9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-64",
    cx: 173.1102,
    cy: 705.5639,
    r: 73.7703,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    stopColor: "#51c4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    stopColor: "#5dbdc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    stopColor: "#71b1d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89a4e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crystal_scroll_svg__linear-gradient",
    x1: 190.711,
    y1: 743.0888,
    x2: 282.9376,
    y2: 729.5796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ab8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897ac2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-65",
    cx: 155.6117,
    cy: 759.2832,
    r: 119.5325,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79c6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#79c2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3702,
    stopColor: "#78b6bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    stopColor: "#76a1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    stopColor: "#7485c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#7161c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7052c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-66",
    cx: 214.377,
    cy: 344.7143,
    r: 473.5353,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#389f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#6a5e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-67",
    cx: 237.3956,
    cy: 690.8022,
    r: 95.0915,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient-66"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-68",
    cx: 4.7802,
    cy: 476.6484,
    r: 491.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    stopColor: "#409592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#616a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#764fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-69",
    cx: 120.033,
    cy: 514.0989,
    r: 361.0635,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-68"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-70",
    cx: 165.9738,
    cy: 515.6157,
    r: 341.233,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-68"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-71",
    cx: 161.4685,
    cy: 425.1176,
    r: 432.0992,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-68"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-72",
    cx: 74.1417,
    cy: 398.1372,
    r: 585.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fbf8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-73",
    cx: 158.8022,
    cy: 419.1538,
    r: 477.4603,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-72"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-74",
    cx: 295.6813,
    cy: 406.0989,
    r: 136.3377,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-72"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-75",
    cx: 334.7249,
    cy: 391.6733,
    r: 187.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ec492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e45a2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-76",
    cx: 357.1593,
    cy: 529.9231,
    r: 111.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    stopColor: "#5dc3b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7972,
    stopColor: "#75dab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80e6b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-77",
    cx: 422.8288,
    cy: 369.8663,
    r: 88.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65d4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57c4c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-78",
    cx: 451.4492,
    cy: 420.7578,
    r: 48.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#609fcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59c4c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-79",
    cx: 494.8681,
    cy: 440.243,
    r: 78.6099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9282c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59b6c0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-80",
    cx: 274.8242,
    cy: 495.2103,
    r: 184.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ee5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a5dd6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-81",
    cx: 264.956,
    cy: 501.044,
    r: 166.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4eddb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8360ca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-82",
    cx: 303.6142,
    cy: 366.6457,
    r: 265.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dd6be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1924,
    stopColor: "#4fd2be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3875,
    stopColor: "#57c6c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#63b1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#7495c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    stopColor: "#8971c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6cc8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-83",
    cx: 502.1868,
    cy: 604.2059,
    r: 179.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#924396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5abdea"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-84",
    cx: 250.0549,
    cy: 588.2088,
    r: 138.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#858ce2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-85",
    cx: 475.6813,
    cy: 633.1758,
    r: 127.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#714aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    stopColor: "#885cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7444,
    stopColor: "#a673c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b17cc6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-86",
    cx: 525.4264,
    cy: 676.6074,
    r: 156.6053,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#6f4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#7659c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#836ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#958adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-87",
    cx: 455.9011,
    cy: 757,
    r: 184.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9685d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    stopColor: "#9286d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#8689d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#728dd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d8ed9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-88",
    cx: 468.6886,
    cy: 702.1204,
    r: 135.2652,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9062d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    stopColor: "#9066d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#8f72d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#8e87ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    stopColor: "#8da3ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-89",
    cx: 367.8878,
    cy: 791.9331,
    r: 211.1568,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b6ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#6d6ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#747ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    stopColor: "#7f8ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8da8c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-90",
    cx: 386.725,
    cy: 938.8081,
    r: 314.906,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7835c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7739c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#7345c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    stopColor: "#6e5ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7306,
    stopColor: "#6676c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    stopColor: "#5c9ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56aec4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-91",
    cx: 387.2594,
    cy: 738.6255,
    r: 118.0265,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#5e47c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#6a52c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#7f66ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    stopColor: "#9b81d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#af94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-92",
    cx: 322.021,
    cy: 645.2912,
    r: 159.2193,
    gradientTransform: "translate(44.8905 -30.0621) rotate(4.1431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#5e4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#6859c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#7a6ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#938adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-93",
    cx: 334.4531,
    cy: 404.4321,
    r: 207.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dd0b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#50cab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#59b8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    stopColor: "#679bcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d90d2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-94",
    cx: 337.0001,
    cy: 468.4815,
    r: 119.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dbcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    stopColor: "#50b8bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#59acc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#6898cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7fd7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-95",
    cx: 289.3516,
    cy: 600.1791,
    r: 99.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#818cd3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-96",
    cx: 281.3297,
    cy: 521.9479,
    r: 122.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4edd9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9183d6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-97",
    cx: 285,
    cy: 540.5154,
    r: 139.6697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60d0b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#825dd6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-98",
    cx: 123.5276,
    cy: 645.9386,
    r: 229.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1848,
    stopColor: "#45a894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    stopColor: "#796792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-99",
    cx: 277.3615,
    cy: 717.217,
    r: 41.8023,
    gradientTransform: "matrix(0.9999, 0.0133, -0.0133, 0.9999, 10.26, -4.1564)",
    xlinkHref: "#crystal_scroll_svg__radial-gradient-98"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-100",
    cx: 240.3958,
    cy: 614.2868,
    r: 192.7572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#329294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    stopColor: "#537993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5684,
    stopColor: "#736293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8247,
    stopColor: "#875392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-101",
    cx: 192.7033,
    cy: 667.6556,
    r: 157.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0603,
    stopColor: "#3ab594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#5e8993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#786992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8476,
    stopColor: "#885592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e4e92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-102",
    cx: 181.0388,
    cy: 715.893,
    r: 107.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#35bc94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#608195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#7c5c96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864e96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-103",
    cx: 223.7992,
    cy: 699.2548,
    r: 80.8996,
    xlinkHref: "#crystal_scroll_svg__radial-gradient-102"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-104",
    cx: 180.4907,
    cy: 680.6716,
    r: 164.0392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#617eaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2609,
    stopColor: "#657dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5254,
    stopColor: "#7078ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#8271ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9669e4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-105",
    cx: 353.7305,
    cy: 732.0601,
    r: 89.6682,
    gradientTransform: "translate(-15.1671 9.7486) rotate(-1.9344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8756aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    stopColor: "#8658ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    stopColor: "#835cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    stopColor: "#7e65ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796ee6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-106",
    cx: 231.5451,
    cy: 768.5515,
    r: 125.1712,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2757,
    stopColor: "#6e74d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5552,
    stopColor: "#7668d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    stopColor: "#8354cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d44c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "crystal_scroll_svg__radial-gradient-107",
    cx: 124.2277,
    cy: 789.6841,
    r: 220.8207,
    gradientTransform: "translate(-14.6958 9.5377) rotate(-1.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    stopColor: "#7c7dd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#887dd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#9c7eca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a17ec9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367,250a386.8559,386.8559,0,0,1-7,59c-1.4722,7.4749-2.7419,13.7846-6,26l-19.2929,72.3338L393,424l37.2444,28.196,38.5088,14.7334q-10.1172-48.6918-20.2345-97.3836Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,430l-13,23,38,14Q456.5,448.5,444,430Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,401l-16,23,38,29,13-23Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,383l-38,24,59,17,16-23Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,310l-33,24q-10,36.5-20,73l39-24Q380,346.5,387,310Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,291l-28,20q-2,11.5-4,23l32-24Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,250l-9,61,28-20Q376.5,270.5,367,250Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-7)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg___Layer_",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387,310q-8.5,36-17,72l8,2,65-12,6-2-17-19Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,290q.5,10,1,20l62,60-53-70Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,250q9.5,20.5,19,41,61.362,80.2008,63,79Q450.9641,368.559,367,250Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,370l-3,4-34,26-3,1-39-19Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,370l-40,31,35,29,3-10q1-22,2-44Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,370q-2.5,30-5,60l25,35Q459,417.5,449,370Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449,370q12.1554,57.9726,12,58-.15.0319-12-55l-3,30q1-16,2-32l-25,19,24-20-14-15,12.0964,11.34Q447.0482,368.17,449,370Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner-2",
    "data-name": "inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.9531,294.5744Q245.9766,318.7872,257,343q11,47.5,22,95,14,34,28,68l63-121q6.5-38.5,13-77-2.5-11.5-5-23l-33-62-43-45-69,95Q233.9765,283.7873,234.9531,294.5744Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes-2",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235,295l52,56-29-6Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,343q11,47.5,22,95l22-15q-7-36-14-72Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,406l22,17-8,14-25-6Q323.5,418.5,329,406Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,385l-41,21,22,17Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,423l17,8,24,7-35,68q-14-34-28-68Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-19)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes_copy_5",
    "data-name": "shapes copy 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,272l6,23,52,56,17-5q5-20.5,10-41l-79-32Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,272l74.1539-2.6969L305,272q2.5,16,5,32v4Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,272l74.1539-2.6969L307,264l3.2559-21.9469L301,171Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5638,423.386q-6.8591-36.2492-13.7183-72.4984L301,343l1,2q-.5,38-1,76Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,431q5.5-12.5,11-25l1-4-18-89-2-5-9,35-.4362,80.386L303,426l13,6Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5638,423.386,307,506q5.5-37.5,11-75Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,242l21.2112-1.6415q1.941-1.4967,3.8985-3.1307a127.8005,127.8005,0,0,0,16.4611-16.554L301,171Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,242l3,4,71,44h3q-8.2283-17.1723-17.28-34.9081-9.0491-17.7063-18.1492-34.4181Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,242l77,48v20.4615L385,311l-67-32q-4-17-8-34Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,278l68,32.4615Q378.5,347.7308,370,385l-3-1-54-69-3-7q.5-4,1-8l7-21Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,308q9.5,49,19,98l41-21Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,278l-9,30q-3.423-19.3485-6.8461-38.6969Q306.5771,255.6516,310,242Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-31)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights_copy_2",
    "data-name": "highlights copy 2",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,171l17,17-16-15,3,30q-2-15-4-30-18.7663,25.1741-19,25Q281.7588,197.8236,301,171Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,246l-7,22-40,3,40-1,6,29q-2-15-4-30Q306.5,257.5,309,246Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,297l28,13q-4,18-8,36,3.5-17.5,7-35Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner-3",
    "data-name": "inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,272l58,79q16,36.7308,32,73.4615,3.5,19.5,7,39,.5,27,1,54,9.5,36,19,72Q342.5,613.2308,339,637l-19,35.4615L214,644l-74-85,32-54.5385Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes-3",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,644l7-21-80-62Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,623l83,11q8,19,16,38L214,644Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,618l25,18-19,36q-8-19-16-38Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,577l21,12q-3.5,24-7,48l-25-19Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,503l17,15q9.5,36,19,72l-21-13Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,458l12,5q.5,27.5,1,55l-17-16Q312,480,314,458Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,427l10-2q3.5,18.5,7,37l-12-3Q311.5,443,309,427Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,351l32,74-10,2Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,272l6,17,52,62Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-41)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg___Layer_2",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235,289q.5,10.5,1,21,8.5,40,17,80l32-30q1-4.5,2-9Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,351q11,38.2308,22,76.4615,2.5,15,5,30Q312,480.2308,310,503l-3-2-39-52-14.2986-61.764Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,452q-8.244,22.3005-17,45-11.399,29.5369-23,58L121,515l-7-4L235,289Q252.5,370.5,270,452Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,561l-27-50,115.5,41.8634L230,558l-6,58-3,7Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6034,540.3932,275,512l50,65Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,553q-4,35-8,70l15-5,81-35,8-6-63-37Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,577,221,623l58,8,35-13Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,512l-6-58q.5-3,1-6l41,55,15,74Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,448q-9.33,25.1091-18.7693,50.1821Q239.9278,525.5505,229.5,552.8634L261,540l14.2166-26.6715Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,366l42-77-6-17Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,631l35-13-10,16Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-52)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights_copy_3",
    "data-name": "highlights copy 3",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270,448l3,42q-2-20-4-40l-13,33,12-35q-9.4764-46.8942-9-47Q259.4794,400.898,270,448Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,551l-32-9,30,12q-1,12.5-2,25,2.5-12.5,5-25l31-13,9-19-10,18Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,471l-18,39,57,23-57-19,19,39-23-42Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__left-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner-4",
    "data-name": "inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336,613c-2.9769,12.36-7.2573,29.1909-13,49-5.2314,18.0452-14.4025,49.462-30,89-10.3051,26.1223-21.15,50.1381-32,72l-25.987-39.3272q-10.4184-42.6786-20.8369-85.3571Q177.088,628.658,140,559l99,44Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-53)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes-4",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,603l-18,19-82-64Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,603l-18,18,84,11,37-23Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,632l37-23-20,57-30,15Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,754l34-5q10-41.5,20-83l-30,15Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,754l34-5-41,74Q264.5,788.5,268,754Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-58)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg___Layer_3",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221,621l-6,76-1.307,1.832Q176.3465,628.416,139,558Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,621l5,7,61,51,5,1.4615L305,632Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,621q-.5,3.5-1,7l15,84c15.6845-7.5821,31.7435-16.1958,48-26q4.5642-2.7527,9-5.5385Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,680.4615,285,697l-44,80-6,7q-.5-7-1-14V716l2-5Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.693,698.832Q215.3465,700.916,217,703l15,9,4-1-15-90h0Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,711q-.5,36.5-1,73-10.6536-42.584-21.307-85.168Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,681,235,784l5-2,24-23,4-5Q279.5,717.5,291,681Z",
    style: {
      fill: "url(#crystal_scroll_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,754l-33,30,26,39Q264.5,788.5,268,754Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-65)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights-2",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,667q4,21.5,8,43l32-17-32,19q-.5,13-1,26-.5-13.5-1-27Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,784l11,16-9-16,20-20Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__right-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner-5",
    "data-name": "inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,586q-3.5,19.5-7,39l-9,17q-3.5,22.5-7,45l31.239,76.333,39.52,21.9125q55.1142-49.8,110.2282-99.5993,7.4943-25.2256,14.9888-50.4513,8.4252-10.678,16.85-21.356,6.76-19.25,13.5193-38.5-3.83-17.1633-7.66-34.3266Q471.3425,503.5063,466,466q-11.5-17.5-23-35l-35-30-38-18-56,20-26,38.4615q-8,38-16,76Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes-5",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289,763l16-4,24,26Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,687l33-6q7,39,14,78l-16,4Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,646l40-11q-5.5,23-11,46l-33,6Q260,666.5,262,646Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,617l-39,9-12,20,40-10Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,580l-41,6q-3.5,20-7,40l39-9Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,517l37-15q6.5,39,13,78l-41,6Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,441l29-10q-4,35.5-8,71l-37,15Q280,479,288,441Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,403l-26,38,28-9,13-27Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,403l56-21-41,23Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-75)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg___Layer_4",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329,405l3,3,9,103-34-9q5-35.2692,10-70.5385Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,382l26,25,14-7Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,400l-14,5,45,38,3-15Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,465q-12.5-18.5-25-37-2.5,7.5-5,15l11,11Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,510l-33-8q14,29.5,28,59l33-9Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-80)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,551l-22,8,13,6,52,16Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.3574,575.01,482,575l-57-65a777.1047,777.1047,0,0,1-52-119q-1.5336-4.5079-3-9l33,21,39,33,27,29Q477.1788,520.005,485.3574,575.01Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,614q7.1787-19.495,14.3574-38.99Q455.6789,542.005,426,509l-10,9-18,54,3,10Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,579l2,8q-2,15.5-4,31L291,681l12-48q5-8.2692,10-16.5385L319,612l68-30Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.9033,635.522,471,614l-71-35,3,8,46,46Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,579q-4,20-8,40,1,3.5,2,7l42,58,3.2474,1.5939q7.3279-25.0359,14.6559-50.0719Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,619,291,681l88,25q7-41.5,14-83Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,619q-7,45-14,90l49-17,12.2474-6.4061Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,704l-30,38-48-48-10-13Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,681l59,60q-9.5,20.5-19,41l-2,3a581.22,581.22,0,0,1-29-73Q294.8922,696.0772,291,681Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-90)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.561,759.43,329,785,291,681Q297.78,720.2149,304.561,759.43Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.2205,685.9666,379,704l-30,36-20,45Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,382l-41,23q5.5,52.5,11,105l72,4,14-4Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,510l18,42,42,27q13-35,26-70Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,580l-9,36.4615L400,579Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,580l-15-79,32,58Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,559l61,20-78,1Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-97)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights-3",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422,507l-38-99,43,100,45,52-46-47-18,47,15-49-31-2Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,633l-12,69-37-8,36,11-16,22,20-22,36-12-36,9Z",
    style: {
      fill: "#f2f2f2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__inner-6",
    "data-name": "inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,669l-36,71-6,30q5.5,26.5,11,53l31,11,37-49-18-33Q301.5,710.5,292,669Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-98)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__shapes-6",
    "data-name": "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,759l23,26-18-33Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,669q-.5,6-1,12l15,78,5-7Q301.5,710.5,292,669Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-100)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,740l9,16,26-75q.5-6,1-12Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-101)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,770l12,53q2-33.5,4-67Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-102)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,770l16-14-9-16Q252.5,755,249,770Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-103)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg___Layer_5",
    "data-name": "<Layer>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265,756q-2,33.5-4,67l3-3,31-56q-2-41.5-4-83Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-104)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,681q1,41,2,82l3,3,29,18,4,1-23-26Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,836l37-51-36-22-1,3q-.5,34-1,68Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-106)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,763l-32,60,31,13Q292.5,799.5,293,763Z",
    style: {
      fill: "url(#crystal_scroll_svg__radial-gradient-107)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "crystal_scroll_svg__highlights-4",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293,832l33-43-34,47-28-12,27,9q.5-12,1-24Q292.5,820.5,293,832Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,736v27l-12,23,13-23Q292.5,749.5,292,736Z",
    style: {
      fill: "#f2f2f2"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCrystalScroll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crystal_scroll.b7371723567696d5f8be615d590cd5c3.svg";